import React from "react";
import PropTypes from "prop-types";
import { CourseCard } from "../../../../components/CourseCard";

const TrainingLink = ({
  id,
  name,
  courseNumber,
  courseType,
  imageUrl,
  flags,
  manualName
}) => {
  return (
    <CourseCard
      id={id}
      number={courseNumber}
      title={name}
      typeName={courseType}
      courseType={courseType}
      imageSrc={imageUrl}
      flags={flags?.split(",")}
      manualName={manualName}
    />
  );
};

export default TrainingLink;

TrainingLink.propTypes = {
  id: PropTypes.string,
  courseNumber: PropTypes.string,
  name: PropTypes.string,
  courseType: PropTypes.string,
  imageSrc: PropTypes.string,
  flags: PropTypes.arrayOf(PropTypes.string),
  manualName: PropTypes.string
};
